import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { getLeadSources } from 'features/newsales/newsalesActions';
import LeadSourceImage from 'pages/settings/salesNewSettings/components/LeadSourceImage';

import { useLeadForm } from '../LeadFormContext';
import {
  Container,
  ErrorMessage,
  ItemTitle,
  LoadingSpinner,
  MainInfoContent,
  SourceGrid,
  SourceImageWrapper,
  SourceItem,
  SubTitle,
  Title,
} from './SourceInfo.styles';

const SourceInfo = ({ onValidationChange, shouldValidate }) => {
  const dispatch = useDispatch();
  const { formData, updateFormData } = useLeadForm();
  const [activeSource, setActiveSource] = useState(formData.leadSourceId);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const fetchSources = async () => {
      setLoading(true);
      try {
        let allSources = [];
        let page = 1;
        const limit = 12;
        let hasMore = true;

        while (hasMore) {
          const result = await dispatch(
            getLeadSources({
              status: 'enabled',
              page,
              limit,
            })
          );

          const responseData = result.payload?.data || [];
          allSources = [...allSources, ...responseData];

          hasMore = responseData.length === limit;
          page += 1;
        }

        setSources(allSources);
      } catch (error) {
        console.error('Error fetching lead sources:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSources();
  }, [dispatch]);

  useEffect(() => {
    updateFormData({ leadSourceId: activeSource });
  }, [activeSource]);

  useEffect(() => {
    const isValid = !!activeSource;
    if (onValidationChange) {
      onValidationChange(isValid);
    }
  }, [activeSource]);

  useEffect(() => {
    if (shouldValidate && !activeSource) {
      setShowError(true);
    }
  }, [shouldValidate, activeSource]);

  const handleSourceClick = (sourceId) => {
    setActiveSource(sourceId);
    setShowError(false);
  };

  return (
    <Container>
      <Title>Select Source</Title>
      <SubTitle>Select source</SubTitle>
      <MainInfoContent>
        {loading ? (
          <LoadingSpinner>Loading sources...</LoadingSpinner>
        ) : (
          <>
            <SourceGrid>
              {sources.map((source) => (
                <SourceItem
                  key={source.id}
                  isActive={activeSource === source.id}
                  onClick={() => handleSourceClick(source.id)}
                >
                  <SourceImageWrapper>
                    <LeadSourceImage imagePath={source.image} alt={source.name} size={64} />
                  </SourceImageWrapper>
                  <ItemTitle>{source.name}</ItemTitle>
                </SourceItem>
              ))}
            </SourceGrid>
            {showError && !activeSource && (
              <ErrorMessage>Please select a source to continue</ErrorMessage>
            )}
          </>
        )}
      </MainInfoContent>
    </Container>
  );
};

export default SourceInfo;
